import { render, staticRenderFns } from "./Massban.vue?vue&type=template&id=76da6352"
import script from "./Massban.vue?vue&type=script&lang=js"
export * from "./Massban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports